"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestedRunDestination = exports.RunDestination = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../base-utils/map-creator");
var constants_1 = require("../../../utils/constants");
var run_properties_destination_1 = require("../character-properties/run-properties-destination");
var destination_1 = require("../destination");
var drawing_destination_1 = require("../drawing/drawing-destination");
var field_char_destination_1 = require("../field/field-char-destination");
var range_permission_end_element_destination_1 = require("../range-permission/range-permission-end-element-destination");
var range_permission_start_element_destination_1 = require("../range-permission/range-permission-start-element-destination");
var carriage_return_destination_1 = require("./carriage-return-destination");
var custom_run_destination_1 = require("./custom-run-destination");
var data_container_run_destination_1 = require("./data-container-run-destination");
var deleted_text_destination_1 = require("./deleted-text-destination");
var inline_object_destination_1 = require("./inline-object-destination");
var inline_picture_destination_1 = require("./inline-picture-destination");
var run_break_destination_1 = require("./run-break-destination");
var run_tab_destination_1 = require("./run-tab-destination");
var separator_destination_1 = require("./separator-destination");
var symbol_destination_1 = require("./symbol-destination");
var text_destination_1 = require("./text-destination");
var RunDestination = (function (_super) {
    tslib_1.__extends(RunDestination, _super);
    function RunDestination(data) {
        var _this = _super.call(this, data) || this;
        _this.resetProperties();
        return _this;
    }
    RunDestination.prototype.resetProperties = function () {
        this.data.subDocumentInfo.characterImporter
            .resetProperties()
            .resetStyle();
    };
    Object.defineProperty(RunDestination.prototype, "elementHandlerTable", {
        get: function () {
            return RunDestination.handlerTable;
        },
        enumerable: false,
        configurable: true
    });
    RunDestination.prototype.isChoiceNamespaceSupported = function (requeriesNamespaceUri) {
        var requeriesNamespaceUriLowerCase = requeriesNamespaceUri.toLowerCase();
        return requeriesNamespaceUriLowerCase == this.data.constants.namespaces[constants_1.DocxNsType.Wps].namespace.toLowerCase() ||
            requeriesNamespaceUriLowerCase == this.data.constants.namespaces[constants_1.DocxNsType.DrawingMLPicture].prefix.toLowerCase() ||
            requeriesNamespaceUriLowerCase == this.data.constants.namespaces[constants_1.DocxNsType.Wpg].namespace.toLowerCase() ||
            requeriesNamespaceUriLowerCase == this.data.constants.namespaces[constants_1.DocxNsType.Wpc].namespace.toLowerCase() ||
            _super.prototype.isChoiceNamespaceSupported.call(this, requeriesNamespaceUri);
    };
    RunDestination.handlerTable = new map_creator_1.MapCreator()
        .add('r', function (data) { return new NestedRunDestination(data); })
        .add('rPr', function (data) { return new run_properties_destination_1.RunPropertiesDestination(data, data.subDocumentInfo.characterImporter.properties); })
        .add('t', function (data) { return new text_destination_1.TextDestination(data); })
        .add('noBreakHyphen', function (data) {
        data.subDocumentInfo.characterImporter.insertText('-');
        return null;
    })
        .add('instrText', function (data) { return new text_destination_1.TextDestination(data); })
        .add('cr', function (data) { return new carriage_return_destination_1.CarriageReturnDestination(data); })
        .add('br', function (data) { return new run_break_destination_1.RunBreakDestination(data); })
        .add('tab', function (data) { return new run_tab_destination_1.RunTabDestination(data); })
        .add('pict', function (data) { return new inline_picture_destination_1.InlinePictureDestination(data); })
        .add('object', function (data) { return new inline_object_destination_1.InlineObjectDestination(data); })
        .add('fldChar', function (data) { return new field_char_destination_1.FieldCharDestination(data); })
        .add('drawing', function (data) { return new drawing_destination_1.DrawingDestination(data); })
        .add('footnoteRef', function (_data) { return null; })
        .add('endnoteRef', function (_data) { return null; })
        .add('commentReference', function (_data) { return null; })
        .add('spr', function (data) { return new separator_destination_1.SeparatorDestination(data); })
        .add('customObject', function (data) { return new custom_run_destination_1.CustomRunDestination(data); })
        .add('dataContainer', function (data) { return new data_container_run_destination_1.DataContainerRunDestination(data); })
        .add('sym', function (data) { return new symbol_destination_1.SymbolDestination(data); })
        .add('delText', function (data) { return new deleted_text_destination_1.DeletedTextDestination(data); })
        .add('permStart', function (data) { return new range_permission_start_element_destination_1.RangePermissionStartElementDestination(data); })
        .add('permEnd', function (data) { return new range_permission_end_element_destination_1.RangePermissionEndElementDestination(data); })
        .get();
    return RunDestination;
}(destination_1.ElementDestination));
exports.RunDestination = RunDestination;
var NestedRunDestination = (function (_super) {
    tslib_1.__extends(NestedRunDestination, _super);
    function NestedRunDestination(data) {
        return _super.call(this, data) || this;
    }
    NestedRunDestination.prototype.resetProperties = function () {
    };
    return NestedRunDestination;
}(RunDestination));
exports.NestedRunDestination = NestedRunDestination;
